import React from 'react';
import { Card, makeStyles, Typography, Box, Divider } from '@material-ui/core';
import mobileAppStyles from './mobileApp.styles';
import { string, shape } from 'prop-types';
import IosBadge from '../../assets/icons/download_AppStore.svg';
import AndroidBadge from '../../assets/images/download_Playstore.png';

const MobileApp = (props) => {
  const { app } = props;
  const { icon, androidUrl, iosUrl, title, comment } = app;
  const useStyles = makeStyles(mobileAppStyles);
  const classes = useStyles();

  return (
    <Card className={classes.container}>
      <Box className={classes.contentWrapper}>
        <Box className={classes.leftSection}>
          <Box className={classes.iconWrapper}>
            <img alt={`${title} icon`} src={icon} className={classes.icon} />
          </Box>
        </Box>
        
        <Box className={classes.middleSection}>
          <Typography variant="h5" className={classes.title}>
            {title}
          </Typography>
          <Typography variant="body1" className={classes.comment}>
            {comment}
          </Typography>
        </Box>

        <Divider orientation="vertical" flexItem className={classes.divider} />
        
        <Box className={classes.rightSection}>
          <Box className={classes.storeButtons}>
            {androidUrl && (
              <a
                href={androidUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.storeLink}
              >
                <img src={AndroidBadge} alt="Download on Google Play" className={classes.storeBadge} />
              </a>
            )}
            {iosUrl && (
                <a
                    href={iosUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.storeLink}
                >
                    <img src={IosBadge} alt="Download on App Store" className={classes.storeBadge} />
                </a>
            )}
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

export default MobileApp;

MobileApp.propTypes = {
  app: shape({
    icon: string.isRequired,
    androidUrl: string,
    iosUrl: string,
    title: string.isRequired,
    comment: string.isRequired
  }).isRequired
};